module.exports = __webpack_public_path__ + "static/media/portfolio4.111dacf7.jpg";